import AuthStore from "../../store/AuthStore";

interface CacheObject {
    expire: Date;
    value: any;
}

export interface CacheCheckResult {
    result: boolean;
    value: any;
}

export default class LicenceCache {
    static getItemCache(authStore: AuthStore, key: string): string {
        let res: CacheObject = null;
        if (authStore) {
            res = authStore.storage[key];
        }
        if (!res || res.expire < new Date()) {
            return null;
        }
        return res.value;
    }

    static getFromCache(authStore: AuthStore, key: string): CacheCheckResult
    {
        let res: CacheObject = null;
        if (authStore) {
            res = authStore.storage[key];
        }
        if (!res || res.expire < new Date()) {
            return { result: false, value: null };
        }
        return { result: true, value: res.value };
    }
    static setToCache(authStore: AuthStore, key: string, value: any, duration: number) {
        let expire: Date = new Date();
        expire.setSeconds(expire.getSeconds() + duration);
        const res: CacheObject = {
            expire: expire,
            value: value
        }
//        localStorage.setItem(key, JSON.stringify(res));
        if (authStore) {
            authStore.storage[key] = res;
        }
    }

}